import { render, staticRenderFns } from "./Reset.htm?vue&type=template&id=bf8a1682&scoped=true&"
import script from "./Reset.js?vue&type=script&lang=js&"
export * from "./Reset.js?vue&type=script&lang=js&"
import style0 from "./Reset.scss?vue&type=style&index=0&id=bf8a1682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8a1682",
  null
  
)

export default component.exports